export default function createCarouselPalette(theme, current, _base) {
    return {
        carousel: {
            navigation: {
                item: {
                    backgroundColor: current[50],
                    button: {
                        backgroundColor: "transparent",
                    },
                    active: {
                        button: {
                            backgroundColor: current[500],
                            autoplay: {
                                linearGradientColor: current[500],
                            },
                            disabled: {
                                backgroundColor: current[300],
                            },
                        },
                    },
                    passed: {
                        button: {
                            backgroundColor: current[500],
                            disabled: {
                                backgroundColor: current[300],
                            },
                        },
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=carousel.js.map